import React from 'react';

import { RadioLabel, RadioItem, RadioInput as Radio } from './RadioStyles';

type Props = {
  register: any;
  disabled?: boolean;
  value: string | number;
  onClick?: () => void;
};

export const RadioInput: React.FC<Props> = ({
  register,
  children,
  disabled,
  value,
  onClick,
}) => {
  return (
    <RadioLabel>
      <Radio
        {...register}
        type='radio'
        id={`${register.name}-${value}`}
        data-testid={`${register.name}-${value}`}
        value={value}
        disabled={disabled}
        onClick={onClick}
      />
      <RadioItem htmlFor={`${register.name}-${value}`} />
      {children && children}
    </RadioLabel>
  );
};
